import {Button, DatePicker, Dropdown, Icon, InputNumber, Menu, Upload} from "antd";
import React from "react";
import Select from "../../components/Select";
import Moment from 'moment';
import EmphasizeText from '../../components/EmphasizeText';

export const uploadType = {
    designFile: 0,
    productImage: 1
};

export const expandedRowRender = (record) => {
    return (
        <table>
            <tbody>
            <tr>
                <td>库存地点</td>
                <td>{record['stock_place']}</td>
            </tr>
            <tr>
                <td>销售订单</td>
                <td>{record['sale_no']}</td>
            </tr>
            <tr>
                <td>材料描述</td>
                <td>{record['material_description']}</td>
            </tr>
            <tr>
                <td>检验文本</td>
                <td>{record['check_text']}</td>
            </tr>
            <tr>
                <td>材料短描述</td>
                <td>{record['product_short_description']}</td>
            </tr>
            <tr>
                <td>确认日期</td>
                <td>{record['confirm_date']}</td>
            </tr>
            <tr>
                <td>产品类别</td>
                <td>{record['category_name']}</td>
            </tr>
            </tbody>
        </table>
    )
};

export const deliveryModalFields = [
    {
        dataIndex: 'id',
        visible: false,
    },
    {
        title: '发货数量',
        dataIndex: 'delivery_qty',
        render: (
            <InputNumber style={{width: '100%'}}/>
        )
    },
    {
        title: '发货时间',
        dataIndex: 'delivery_date',
        initialValue: (record) => {
            return Moment(record ? record['delivery_date'] : undefined)
        },
        render: (
            <DatePicker style={{width: '100%'}}/>
        )
    }
]

export const uploadModalFields = (uploadType, getFile) => [
    {
        dataIndex: 'id',
        visible: false
    },
    {
        title: '',
        dataIndex: 'file',
        render: (

            <Upload name='file' action='' multiple={false} beforeUpload={(file) => {
                getFile(uploadType, file);
                return false
            }}>
                <Button>
                    <Icon type="upload"/> 选择文件
                </Button>
            </Upload>
        )
    }
];

export const deliveryQtyModalFields = (getFile) => [
    {
        title: '文件',
        dataIndex: 'file',
        render: (
            <Upload multiple={false} beforeUpload={file => {
                getFile(file);
                return false
            }}>
                <Button>
                    <Icon type='upload'/> 选择文件
                </Button>
            </Upload>
        )
    }
];

export const planDeliveryModalFields = (getFile) => [
    {
        title: '文件',
        dataIndex: 'file',
        render: (
            <Upload multiple={false} beforeUpload={file => {
                getFile(file);
                return false
            }}>
                <Button>
                    <Icon type='upload'/> 选择文件
                </Button>
            </Upload>
        )
    }
];

export const importModalFields = (getFile) => [
    {
        title: '模板',
        dataIndex: 'template_id',
        rules: [{required: true, message: '请选择模板'}],
        render: (
            <Select url={'/api/report/templates?report_id=1'}
                    getData={data => data.data}
                    textField={'name'}
                    valueField={'id'}
                    style={{width: '100%'}}/>
        )
    },
    {
        title: '文件',
        dataIndex: 'file',
        render: (
            <Upload multiple={false} beforeUpload={file => {
                getFile(file)
                return false
            }}>
                <Button>
                    <Icon type="upload"/> 选择文件
                </Button>
            </Upload>
        )
    }
];

export const importReconciliationModalFields = (getFile) => [
    {
        title: '文件',
        dataIndex: 'file',
        render: (
            <Upload multiple={false} beforeUpload={file => {
                getFile(file)
                return false
            }}>
                <Button>
                    <Icon type="upload"/> 选择文件
                </Button>
            </Upload>
        )
    }
]

export const exportModelModalFields = [
    {
        title: '选择模板',
        dataIndex: 'template_id',
        rules: [{required: true, message: '请选择模板'}],
        render: (
            <Select url={'/api/report/templates?report_id=1'}
                    getData={data => data.data}
                    textField={'name'}
                    valueField={'id'}
                    style={{width: '100%'}}/>
        )
    }
]

export const copyOrderModelFields = [
    {
        dataIndex: 'id',
        visible: false,
    },
    {
        title: '订单数量',
        dataIndex: 'qty',
        render: (
            <InputNumber style={{width: '100%'}}/>
        )
    },
    {
        title: '计划发货时间',
        dataIndex: 'date',
        initialValue: (record) => {
            return Moment(record ? record['date'] : undefined)
        },
        render: (
            <DatePicker style={{width: '100%'}}/>
        )
    }
]

export const modifyModalFields = [
    {
        dataIndex: 'id',
        visible: false
    },
    {
        title: ' 产品ID',
        dataIndex: 'product_no'
    },
    {
        title: '采购订单',
        dataIndex: 'purchase_no',
        rules: [{required: true, message: '请输入采购单号'}]
    },
    {
        title: '行号',
        dataIndex: 'line_no',
        render: (
            <InputNumber style={{width: '100%'}}/>
        ),
        rules: [{required: true, message: '请输入行号'}]
    },
    {
        title: '版本',
        dataIndex: 'version_no'
    },
    {
        title: '客户物料ID',
        dataIndex: 'product_id'
    },
    {
        title: '客户简称',
        dataIndex: 'customer_short_name'
    },
    {
        title: '物料描述',
        dataIndex: 'product_description'
    },
    {
        title: '单位',
        dataIndex: 'unit_id',
        render: (
            <Select url={'/api/unit/'}
                    getData={data => data.data}
                    textField={'name'}
                    valueField={'id'}
                    style={{width: '100%'}}
            />
        )
    },
    {
        title: '数量',
        dataIndex: 'qty',
        render: (
            <InputNumber style={{width: '100%'}}/>
        )
    },
    {
        title: '仓存地点',
        dataIndex: 'stock_place'
    },
    {
        title: '销售订单',
        dataIndex: 'sale_no'
    },
    {
        title: '材料描述',
        dataIndex: 'material_description'
    },
    {
        title: '检验文本',
        dataIndex: 'check_text'
    },
    {
        title: ' 材料短描述',
        dataIndex: 'product_short_description'
    },
    {
        title: '最新计划发货时间',
        dataIndex: 'plan_delivery_date'
    },
    {
        title: '确认日期',
        dataIndex: 'confirm_date',
        initialValue: (record) => {
            return Moment(record ? record['confirm_date'] : undefined)
        },
        render: (
            <DatePicker style={{width: '100%'}}/>
        )
    },
    {
        title: '产品类别',
        dataIndex: 'category_id',
        render: (
            <Select url={'/api/category/'}
                    getData={data => data.data}
                    textField={'name'}
                    valueField={'id'}
                    style={{width: '100%'}}
            />
        )
    },
    {
        title: '主材料名称',
        dataIndex: 'material_id',
        render: (
            <Select url={'/api/material/'}
                    getData={data => data.data}
                    textField={'name'}
                    valueField={'id'}
                    style={{width: '100%'}}
            />
        )
    },
    {
        title: '主材料规格',
        dataIndex: 'material_size',
    },
    {
        title: '单位耗用',
        dataIndex: 'per_consumption',
        rules: [{required: true, message: '请输入单位耗用'}],
        render: (
            <InputNumber style={{width: '100%'}}/>
        )
    },
    {
        title: '单位耗时',
        dataIndex: 'per_time',
        rules: [{required: true, message: '请输入单位耗时'}],
        render: (
            <InputNumber style={{width: '100%'}}/>
        )
    },
    {
        title: '刀模编号',
        dataIndex: 'die_no'
    },
    {
        title: '模具编号',
        dataIndex: 'mould_no'
    },
    {
        title: '结构图纸/图片',
        dataIndex: 'picture_no'
    },
    {
        title: '生产组',
        dataIndex: 'process_group_id',
        render: (
            <Select url={'/api/process/group'}
                    getData={data => data.data}
                    textField={'name'}
                    valueField={'id'}
                    style={{width: '100%'}}
            />
        )
    },
    {
        title: '备注',
        dataIndex: 'remark'
    },
    // {
    //     title: '占用数量',
    //     dataIndex: 'occupy_qty',
    //     render: (
    //         <InputNumber precision={0} min={0} style={{width: '100%'}} />
    //     ),
    //     visible: (record) => {
    //         return record.id !== undefined
    //     }
    // },
];

export const rowEvents = (record, events) => {
    events = !events ? {} : events;
    let resultEvents = {
        onClick: e => {
        }, // 点击行
        onDoubleClick: e => {
        },//双击行
        onContextMenu: e => {
        },
        onMouseEnter: e => {
        }, // 鼠标移入行
        onMouseLeave: e => {
        },
    };
    Object.keys(events).forEach(k => {
        resultEvents[k] = e => events[k](e, record);
    })
    return resultEvents
};

export const workOrderModelFields = [
    {
        title: '日期',
        dataIndex: 'date',
        render: (
            <DatePicker style={{width: '100%'}}/>
        )
    },
    {
        title: '流水号',
        dataIndex: 'no',
        render: (
            <InputNumber style={{width: '100%'}}/>
        )
    }
]
